import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import BasePage from '../../../BasePage/BasePage';
import ImageCarousel from '../../../../atoms/ImageCarousel/ImageCarousel';
import Grid from '../../../../atoms/Grid/Grid';
import InputControl from '../../../../atoms/InputControl/InputControl';
import TagsInput from '../../../../atoms/TagsInput/TagsInput';
import DynastySelector from '../../../../atoms/DynastySelector/DynastySelector';
import CitySelector from '../../../../atoms/CitySelector/CItySelector';
import Button from '../../../../atoms/Button/Button';
import Icon from '../../../../atoms/Icon/Icon';
import { fetchElementsInitAction, updateSelectedElementAction } from '../../../../../actions/instances/elements';
import BuildingsSelector from '../../../../atoms/BuildingsSelector/BuildingsSelector';
import ElementTypeSelector from '../../../../atoms/ElementTypeSelector/ElementTypeSelector';
import ComponentsSelector from '../../../../atoms/ComponentsSelector/ComponentsSelector';
import Api from '../../../../../services/Api';
import extractErrors from '../../../../../helpers/errors';
import InstanceDocumentEditor from '../../../../Organisms/InstanceDocumentEditor/InstanceDocumentEditor';
import CitationEditor from '../../../../molecules/CitationEditor/CitationEditor';
import CharacteristicsSelector from '../../../../atoms/CharacteristicsSelector/CharacteristicsSelector';
import './CreateElement.scss';

const CreateElement = () => {
  const { selectedElement } = useSelector(state => state.buildingElementInstance);
  const [element, setElement] = useState(selectedElement);
  let mainImage;
  let restOfImages = [];
  if (element) {
    if (element.images !== undefined || element.images !== null) {
      if (element.images.length > 0) {
        [mainImage] = element.images;
        restOfImages = element.images.slice(0, 1);
      }
    }
  }
  const [imagesIds, setImagesIds] = useState(restOfImages);
  const [mainImageId, setMainImageId] = useState(mainImage);
  const [name, setName] = useState(element ? element.name : undefined);
  const [elementTypeId, setElementTypeId] = useState(element ? element.element_type : undefined);
  const [dynastyId, setDynastyId] = useState(element ? element.dynasty.id : undefined);
  const [dynastyCode, setDynastyCode] = useState(element ? element.dynasty.code : undefined);
  const [cityId, setCityId] = useState(element ? element.city.id : undefined);
  const [cityCode, setCityCode] = useState(element ? element.city.code : undefined);
  const [buildingsIds, setBuildingsIds] = useState(
    element && element.buildings ? element.buildings.map(b => b.id) : [],
  );
  const [characteristicsIds, setCharacteristicsIds] = useState(
    element && element.characteristics
      ? element.characteristics.map(x => x.id) : undefined,
  );
  const [componentsIds, setComponentsIds] = useState(
    element && element.components ? element.components.map(b => b.id) : [],
  );
  const [resourcesIds, setResourcesIds] = useState(undefined);
  const [documentsIds, setDocumentsIds] = useState(
    element ? element.documents.map(doc => doc.id) : [],
  );
  const [errors, setErrors] = useState(undefined);
  const [tagsIds, setTagsIds] = useState(undefined);
  const [identifier, setIdentifier] = useState(undefined);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (selectedElement) {
      Api.get(`instances/building-elements/${selectedElement.id}`).then((response) => {
        setElement(response.data);
        setBuildingsIds(response.data.buildings.map(x => x.id));
      });
    }
  }, []);
  useEffect(() => {
    let combinedCode = '';
    if (dynastyCode) {
      combinedCode += `${dynastyCode}-`;
    }
    if (cityCode) {
      combinedCode += `${cityCode}-`;
    }
    combinedCode += 'BENXXXX';
    setIdentifier(combinedCode);
  }, [cityCode, dynastyCode]);
  useEffect(() => {
    if (element && element.components) {
      setComponentsIds(element.components.map(c => c.id));
    }
    if (element && element.characteristics) {
      setCharacteristicsIds(element.characteristics.map(c => c.id));
    }
  }, [element]);
  const dispatch = useDispatch();
  const history = useHistory();
  const handleSave = () => {
    if (!name) {
      setErrors('Element name is required');
      return;
    }
    if (!cityId) {
      setErrors('You must select a region for the Element');
      return;
    }
    if (!dynastyId) {
      setErrors('You must select a dynasty for the Element');
      return;
    }
    if (!elementTypeId) {
      setErrors('An must have a type');
      return;
    }
    setLoading(true);
    const data = {
      name,
      code_suffix: 'BEN',
      city_id: cityId,
      dynasty_id: dynastyId,
      images_ids: [mainImageId, ...imagesIds].filter(img => img !== undefined),
      tags_ids: tagsIds,
      buildings_ids: buildingsIds,
      resources_ids: resourcesIds,
      element_type: elementTypeId,
      components_ids: componentsIds,
      documents_ids: documentsIds,
      characteristics_ids: characteristicsIds,
    };
    const callback = (response) => {
      if (response.status === 200 || response.status === 201) {
        dispatch(updateSelectedElementAction(data.data));
        dispatch(fetchElementsInitAction());
        setTimeout(() => {
          setLoading(false);
          history.goBack();
        }, 500);
      } else {
        const errs = extractErrors(response.data);
        setErrors([errs[0]]);
        setLoading(false);
      }
    };
    if (element) {
      Api.patch(`instances/building-elements/${element.id}`, data).then(response => callback(response));
    } else {
      Api.post('instances/building-elements', data).then(response => callback(response));
    }
  };
  console.log(buildingsIds);
  return (
    <BasePage>
      <div className="create-component-container">
        <h2 className="col-md-12">{element ? `Edit ${element.name} [${element.code}]` : 'Create new element'}</h2>
        <br />
        <Grid>
          <div className="col-md-3 left-column">
            <ImageCarousel
              initialImages={element ? element.images : []}
              additionalImagesAddedCallback={images => setImagesIds(images)}
              mainImageAddedCallback={imageId => setMainImageId(imageId)}
            />
            <div className="col-md-12 dynasty-section">
              <InstanceDocumentEditor
                initialDocuments={element ? element.documents : []}
                onFilesChanged={(files) => {
                  setDocumentsIds(files.map(f => f.id));
                }}
              />
            </div>
            <div className="tags-container">
              <label className="tag-label">Component Tags</label>
              <TagsInput tags={tagsIds} placeholder="Start typing..." onChange={tags => setTagsIds(tags)} />
            </div>
          </div>
          <div className="col-md-9 content-column">
            <Grid>
              <div className="col-md-12 dynasty-section">
                <label>Element Type</label>
                <ElementTypeSelector
                  onChanged={(type) => {
                    setElementTypeId(type.value);
                  }}
                  selectedId={element ? element.element_type : undefined}
                />
              </div>
              <div className="col-md-12 dynasty-section">
                <label>Location</label>
                <CitySelector
                  onChanged={(city) => {
                    setCityId(city.value);
                    setCityCode(city.code);
                  }}
                  selectedId={element ? element.city.id : undefined}
                />
              </div>
              <div className="col-md-12 dynasty-section">
                <label>Dynasty</label>
                <DynastySelector
                  onChanged={(dynasty) => {
                    setDynastyId(dynasty.value);
                    setDynastyCode(dynasty.code);
                  }}
                  selectedId={element ? element.dynasty.id : undefined}
                />
              </div>
              <div className="col-md-12">
                <InputControl label="Element name" value={name} type="text" onValueChanged={value => setName(value)} placeholder="Name..." />
                <br />
                <small>{identifier}</small>
              </div>
              <div className="col-md-12 dynasty-section">
                <label>Element Buildings</label>
                <BuildingsSelector
                  cityId={cityId}
                  dynastyId={dynastyId}
                  onChanged={(values) => {
                    const ids = values.map(val => parseInt(val.value, 10));
                    setBuildingsIds(ids);
                  }}
                  selectedIds={buildingsIds}
                />
              </div>
              <div className="col-md-12 dynasty-section">
                <label>Element Characteristics</label>
                <CharacteristicsSelector
                  onChanged={(values) => {
                    const ids = values.map(val => parseInt(val.value, 10));
                    setCharacteristicsIds(ids);
                  }}
                  selectedIds={characteristicsIds}
                  isMulti
                />
              </div>
              <div className="col-md-12 dynasty-section">
                <label>Element Components</label>
                <ComponentsSelector
                  onChanged={(values) => {
                    const ids = values.map(val => parseInt(val.value, 10));
                    setComponentsIds(ids);
                  }}
                  selectedIds={componentsIds}
                />
              </div>
              <div className="col-md-12 dynasty-section">
                <CitationEditor
                  onChange={values => setResourcesIds(values)}
                  initialCitations={element ? element.citation : []}
                />
              </div>
              {errors && (
                <div className="col-md-12 errors-container">
                  <span className="error">{errors}</span>
                </div>
              )}
              <div className="col-md-12 actions">
                <Button onInvoked={() => history.goBack()}>
                  <Icon icon="times" />
                  <span>Cancel</span>
                </Button>
                <Button onInvoked={handleSave} isLoading={loading}>
                  <Icon icon="save" />
                  <span>Save</span>
                </Button>
              </div>
            </Grid>
          </div>
        </Grid>
      </div>
    </BasePage>
  );
};

export default CreateElement;
